import $ from 'jquery';
import createActivityDetector from 'activity-detector';
import ConfigService from './config.service';
import UtilsService from './utils.service';
import UserInfo from './models/userInfo.model';
import Promise from 'promise-polyfill';
import 'whatwg-fetch';
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";

export default class LoginService {

  static init(email, password, isImpersonation) {
    // const routeParams = new URLSearchParams(window.location.search);
    // const ocParam = routeParams.get('oc');

    LoginService.userObject = LoginService.userObject || new UserInfo();
    LoginService.triedSessionLogin = LoginService.triedSessionLogin || false;
    if (!LoginService.authInProgress) {
      return LoginService.dynamicLogin(email, password, isImpersonation);
    } else {
      return LoginService.authPromise;
    }
  }

  static setupAuthMode(orgDomain, authType) {
      LoginService.orgDomain = orgDomain;
      LoginService.authType = authType;
  }

  static startAuthCycle(promise) {
    LoginService.authInProgress = true;
    LoginService.tokensRevoked = false;
    LoginService.authPromise = promise;
    return LoginService.authPromise;
  }

  static isAuthInProgress() {
    return LoginService.authInProgress;
  }

  static dynamicLogin(email, password, isImpersonation) {
    let promise;
    if (window.Config.isInternalAuth || isImpersonation) {
      if (email) {
        promise = LoginService.loginUser(email, password);
      } else {
        promise = LoginService.sessionLogin();
      }
    } else {
      // SSO login
      promise = LoginService.loginSSOUser();
    }
    return LoginService.startAuthCycle(promise);
  }

  static startOneCloudAuth(email) {
      let promise = LoginService.loginOneCloudUser(email);
      return LoginService.startAuthCycle(promise);
  }

  static startSSOAuth() {
      let promise = LoginService.loginSSOUser();
      return LoginService.startAuthCycle(promise);
  }

  static completeSSOAuth() {
      let promise = LoginService.loginSSOUser();
      return LoginService.startAuthCycle(promise);
  }

  static completeOneCloudAuth(email) {
      let promise = LoginService.loginOneCloudUser(email);
      return LoginService.startAuthCycle(promise);
  }

  static completeWxpAuth(wxpToken) {
      console.log("completeWxpAuth - processing wxp token");
      LoginService.userObject = new UserInfo();
      LoginService.userObject.apiToken = { access_token: wxpToken };

      window.addEventListener('storage', function (event) {
          if (event.key === 'indirect_dui_token_e' || event.key === 'dui_token_e') {
              console.log(event.key  + " token updated");
              LoginService.userObject.apiToken = { access_token: LoginService.getWxpToken() };
          }
      });

      let promise = LoginService.getUserJson(wxpToken).then((user) => {
          window.localStorage.setItem('loggedIn-' + user.username, 'true');
          return user;
      });
      return LoginService.startAuthCycle(promise);
  }

  static getWxpToken() {
      let wxpEncryptionKey = Cookies.get("dui_encryptionKey");
      // console.log("wxpEncryptionKey: " + wxpEncryptionKey);
      if (wxpEncryptionKey !== null) {
          let wxpTokenType = localStorage.getItem("token_type");
          if (wxpTokenType === null) {
              // TODO: remove this
              wxpTokenType = sessionStorage.getItem("token_type");
          }
          console.log("wxpTokenType: " + wxpTokenType);

          if (wxpTokenType === "indirect") {
              let wxpIndirectToken = localStorage.getItem("indirect_dui_token_e");
              if (wxpIndirectToken !== null && wxpIndirectToken !== "") {
                  // console.log("wxpIndirectToken: " + wxpIndirectToken);
                  let decryptedWxpIndirectToken = CryptoJS.AES.decrypt(wxpIndirectToken, wxpEncryptionKey).toString(CryptoJS.enc.Utf8);
                  // console.debug("decryptedWxpIndirectToken: " + decryptedWxpIndirectToken);
                  return decryptedWxpIndirectToken;
              } else {
                  console.warn("did not find expected indirect token");
                  return null;
              }
          }

          var wxpDirectToken = localStorage.getItem("dui_token_e");
          if (wxpDirectToken !== null && wxpDirectToken !== "") {
              let decryptedWxpDirectToken = CryptoJS.AES.decrypt(wxpDirectToken, wxpEncryptionKey).toString(CryptoJS.enc.Utf8);
              // console.debug("decryptedWxpDirectToken: " + decryptedWxpDirectToken);
              return decryptedWxpDirectToken;
          } else {
              console.warn("did not find expected direct token");
              return null;
          }
      }
      return null;
  }

  // used to determine the auth type of the user (internal, sso)
  static checkAuthType(email) {
      return new Promise((resolve, reject) => {
          ConfigService.getInstance().getConfig().then(function(config) {
              let url = config.keycloakUrl + '/user/api/v1/authType';
              return fetch(url, {
                  method: 'POST',
                  body: JSON.stringify({
                      username: email
                  }),
                  headers: {
                      "Content-type": "application/json; charset=UTF-8"
                  }
              })
              .then((response) => {
                  if (response.ok) {
                      response.json().then((json) => {
                          return resolve(json);
                      });
                  } else {
                      return reject('Could not determine auth type.');
                  }
              }, (error) => {
                  return reject(error);
              });
          });
      });
  }

    static sessionLogin() {
        if (LoginService.triedSessionLogin || (window.Config.iframeMode && LoginService.getWxpToken()) ) {
            return Promise.reject('sessionLogin skipped');
        }

        return new Promise(function (resolve, reject) {
            return ConfigService.getInstance().getKeycloakUrl().then(function (authServiceUrl) {
                LoginService.triedSessionLogin = true;
                let url = authServiceUrl + '/oauth2/token';
                let params = {
                    client_id: 'vyopta',
                    grant_type: 'refresh_token_cookie',
                    scope: 'openid',
                };
                return fetch(url, {
                    method: 'POST',
                    credentials: 'include',
                    body: $.param(params),
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                })
                .then(function (response) {
                    if (response.ok) {
                        response.json()
                            .then((token) => {
                                return resolve(LoginService.handleAuth(token).then((user) => {
                                    window.localStorage.setItem('loggedIn-' + user.username, 'true');
                                    return user;
                                }));
                            });
                    } else {
                        logoutHelper();
                        return reject('Refresh token login failed');
                    }
                }, function (error) {
                    return reject(error);
                });
            }, function (error) {
                return reject(error);
            });
        });
    }

  static loginUser(email, password) {
      LoginService.isLoggedOut = false;
      return new Promise((resolve, reject) => {
      LoginService.fetchJWT(email, password)
        .then((response) => {
          if (response.ok) {
            response.json()
            .then((token) => {
              return resolve(LoginService.handleAuth(token).then((user) => {
                window.localStorage.setItem('loggedIn-' + user.username, 'true');
                return user;
              }));
            });
          } else {
            return reject('Login Failure');
          }
        }, (error) => {
          return reject(error);
        });
      });
  }

  static loginOneCloudUser(email) {
      LoginService.isLoggedOut = false;
      LoginService.triedSessionLogin = true;
      if (isValidCallbackUrl()) {
          console.log("detected OneCloud callback");
          return LoginService.processSSOCallback();
      } else {
          console.log("detected OneCloud login");
          return LoginService.sessionLogin().catch(() => {
              return createOneCloudRequest(email).then((url) => window.location.replace(url));
          });
      }
  }

  static loginSSOUser() {
      LoginService.isLoggedOut = false;
      LoginService.triedSessionLogin = true;
      if (isValidCallbackUrl()) {
          // console.log("detected SSO callback");
          return LoginService.processSSOCallback();
      } else {
          // console.log("detected SSO login");
          return LoginService.sessionLogin().catch(() => {
              return createSSORequest().then((url) => window.location.replace(url));
          });
      }
  }

  static shouldLogout() {
    if (LoginService.isLoggedOut) {
      return true;
    }

    if (LoginService.userObject && LoginService.userObject.username) {
        // check if `loggedIn` is still present in localStorage - if not, it was removed by the
        // logout process in another tab, so we should bail out
        var loggedIn = window.localStorage.getItem('loggedIn-' + LoginService.userObject.username);
        if (!loggedIn) {
            return true;
        }
    }

    return false;
  }

  static getActiveSession() {
    if (LoginService.isLoggedOut) {
      return Promise.reject('');
    }

    if (LoginService.shouldLogout()) {
      return Promise.reject('#logout');
    }

    if (!LoginService.authPromise || LoginService.isAuthInProgress()) {
      return LoginService.init();
    } else if (isTokenExpired()) {
      const token = LoginService.userObject.apiToken;
      return LoginService.refreshToken(token.refresh_token);
    }
    if (LoginService.userObject && LoginService.userObject.userId) {
      return Promise.resolve(LoginService.userObject);
    } else {
      return Promise.reject('');
    }
  }

  static handleAuth(keycloakJWT) {
    // todo
    // if (!keycloakJWT) {
    //   return Promise.reject('empty jwt');
    // }
      LoginService.userObject = new UserInfo({
          apiToken: keycloakJWT
      });

      LoginService.setupApiTokenKeepAlive(keycloakJWT);

      return LoginService.getUserJson(keycloakJWT.access_token);
  }

  static getUserJson(token) {
      return new Promise((resolve, reject) => {
        ConfigService.getInstance().getAuthService().then(function (authService) {
          var url = authService + '/api/v1/users/userInfo';
          return fetch(url, {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
              })
              .then((response) => {
                // todo
                if (response && response.status === 200) {
                  return response.json();
                } else {
                  reject(response.text());
                }
              }, (err) => {
                return reject(err);
              })
              .then(function (userInfoData) {
                // todo
                // if (!userInfoData) {
                //   return Promise.reject('empty user info data');
                // }
                  LoginService.userObject.setUserInfoCallData(userInfoData);

                  LoginService.authInProgress = false;
                  LoginService.triedSessionLogin = false;

                  let idleTimeoutMinutes = userInfoData.idleTimeoutMinutes;
                  if (idleTimeoutMinutes) {
                      // console.log("activityDetector: creating for " + idleTimeoutMinutes + " idle minutes");
                      if (!LoginService.activityDetector) {
                          LoginService.activityDetector = createActivityDetector({
                              inactivityEvents: [],
                              timeToIdle: idleTimeoutMinutes * 60 * 1000, // convert minutes to ms
                          });
                          LoginService.activityDetector.on('idle', function() {
                            // console.log("activityDetector: fired for idle - initiating logout");
                            LoginService.logout();
                            setTimeout(function() {
                                alert('Due to inactivity you have been logged out. Please log back in to continue your session.');
                            },1000);
                          });
                      }
                  }

                  resolve(LoginService.userObject);
              }, (err) => {
                return reject(err);
              });
        }, (err) => {
          return reject(err);
        });
      });
  }

  static setupApiTokenKeepAlive(token) {
      if (LoginService.refreshTimer) {
        clearTimeout(LoginService.refreshTimer);
        LoginService.refreshTimer = undefined;
        // console.log("refreshTokenTimer: cleared previous timer");
      }
      let refreshIn = Math.ceil(1000 * token.refresh_expires_in * 2 / 3);
      // console.log("refreshTokenTimer: creating new timer to fire in " + refreshIn + "ms");
      LoginService.refreshTimer = window.setTimeout(() => {
              // console.log("refreshTokenTimer: timer fired");
              LoginService.refreshToken(token.refresh_token);
          }, refreshIn);
  }

  static fetchJWT(email, password) {
      return new Promise(function(resolve, reject) {
          ConfigService.getInstance().getConfig().then(function(config) {
            let realm = window.Config.keycloakDefaultRealm;

            if (window.Config.hasOwnProperty('isInternalAuth') && !window.Config.isInternalAuth) {
                realm  = window.Config.realmId;
            }

            let url = config.keycloakUrl;
            if (useKeycloakForAuth()) {
                url += '/realms/' + realm + '/protocol/openid-connect/token';
            } else {
                url += '/oauth2/token';
            }
            let params = {
                client_id: config.keycloakClient,
                grant_type: 'password',
                username: email,
                password: password,
                scope: 'openid'
            };

            return fetch(url, {
                method: 'POST',
                credentials: 'include',
                body: $.param(params),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            })
            .then(function(response) {
              return resolve(response);
            },
            function(error) {
              return reject(error);
            });
          }, function (error) {
            return reject(error);
          });
      });
  }

  static keycloakLogout(url, hint, accessToken, refreshToken) {
    return new Promise(function(resolve, reject) {
      ConfigService.getInstance().getConfig().then(function(config) {
          ConfigService.getInstance().getKeycloakUrl().then(function (keycloakUrl) {
              let realm = window.Config.keycloakDefaultRealm;
              if (window.Config.hasOwnProperty('isInternalAuth') && !window.Config.isInternalAuth) {
                  realm  = window.Config.realmId;
              }
              let keycloakLogoutUrl = keycloakUrl + '/api/v1/logout';
              let params = {
                refresh_token: refreshToken
              };
              fetch(keycloakLogoutUrl, {
                  method: 'POST',
                  credentials: 'include',
                  body: $.param(params),
                  headers: {
                      'Authorization': 'Bearer ' + accessToken
                  }
              })
              .then(function(response) {
                  ConfigService.getInstance().getKeycloakUrl().then(function (keycloakUrl) {
                      let realm = window.Config.keycloakDefaultRealm;
                      if (window.Config.hasOwnProperty('isInternalAuth') && !window.Config.isInternalAuth) {
                          realm  = window.Config.realmId;
                      }
                      var logoutUrl = keycloakUrl + '/realms/' + realm
                          + '/protocol/openid-connect/logout?post_logout_redirect_uri=' + encodeURIComponent(url)
                          + '&client_id=' + encodeURIComponent(window.Config.keycloakClient)
                          + '&id_token_hint=' + encodeURIComponent(hint);

                      logoutHelper();
                      window.location.href = logoutUrl;
                  });
                  return resolve(response);
              },
              function(error) {
                logoutHelper();
                window.location.href = url;
                return reject(error);
              });
          }, function (error) {
            return reject(error);
          });
      });
    });
  }

  static swapOauthCodeForJwt(code, redirectUri) {
    return new Promise(function(resolve, reject) {
      ConfigService.getInstance().getConfig().then(function(config) {
        let realm = window.Config.keycloakDefaultRealm;
        if (window.Config.hasOwnProperty('isInternalAuth') && !window.Config.isInternalAuth) {
            realm  = window.Config.realmId;
        }
        var url = config.keycloakUrl;
        if (useKeycloakForAuth()) {
            url += '/realms/' + realm + '/protocol/openid-connect/token';
        } else {
            url += '/oauth2/token';
        }

        var params = {
          client_id: config.keycloakClient,
          grant_type: 'authorization_code',
          code: code,
          redirect_uri: redirectUri
        };

        return fetch(url, {
          method: 'POST',
          credentials: 'include',
          body: $.param(params),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }
        })
        .then(function(response) {
          resolve(response);
        },
        function(error) {
          reject(error);
        });
      });
    });
  }

  static refreshToken(refreshToken) {
      if (!refreshToken) {
          throw new Error('Mandatory argument \'refreshToken\' seems to be missing or invalid.');
      }
      // This function may be called multiple times before the promise resolves, but we don't want to make multiple
      // requests so instead we cache and return the promise that has already been initiated
      if (!LoginService.authInProgress) {
        // We create a new promise here rather than returning the fetch promise since we might need it to resolve
        // within another promise's 'catch' handler
        LoginService.startAuthCycle(new Promise((resolve, reject) => {
          ConfigService.getInstance().getConfig().then(function(config) {
            let url = config.keycloakUrl + '/oauth2/token';
            let params = {
                grant_type: 'refresh_token',
                scope: 'openid',
                client_id: 'vyopta',
                refresh_token: refreshToken
            };
            fetch(url, {
                method: 'POST',
                credentials: 'include',
                body: $.param(params),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            })
            .then((response) => {
                if (response.ok) {
                    response.json().then((json) => {
                        resolve(LoginService.handleAuth(json));
                    });
                } else {
                    // refresh token may be expired, try login from session  token
                    console.log('Error renewing refresh token - trying sessionLogin');
                    return LoginService.sessionLogin().then(()=> {
                        console.log('Error renewing refresh token - sessionLogin worked');
                        return resolve(LoginService.userObject);
                    }, () => {
                        console.log('Error renewing refresh token - sessionLogin failed');
                        LoginService.logout();
                    });
                }
            }, () => {
                // refresh token may be expired, try login from session  token
                console.log("refreshToken fetch failed - trying sessionLogin");
                return LoginService.sessionLogin().then(()=> {
                    return resolve(LoginService.userObject);
                }, () => {
                    console.log('Error renewing refresh token - sessionLogin failed again');
                    LoginService.logout();
                });
              });
            });
        }));
      }
      return LoginService.authPromise;
  }

  static processSSOCallback() {
      var code = getUrlParameter('code');
      var callbackState = JSON.parse(window.sessionStorage.getItem("callbackState"));
      if (!callbackState) {
        return createSSORequest().then((url) => window.location.replace(url));
      }
      var redirectUrl = decodeURIComponent(callbackState.redirectUri);
      // reset the original url from our stored state
      window.Config.originalUrl = decodeURIComponent(callbackState.originalUrl);

      return new Promise((resolve, reject) => {
        LoginService.swapOauthCodeForJwt(code, redirectUrl)
            .then(function(response) {
                if (response.ok) {
                    response.json()
                    .then(function(token) {
                        window.history.replaceState(window.history.state, null, redirectUrl);
                        resolve(LoginService.handleAuth(token).then((user) => {
                          window.localStorage.setItem('loggedIn-' + user.username, 'true');
                          return user;
                        }));
                    }, (err) => reject(err));
                }
            }, (err) => reject(err));
      });
  }

  static logout() {
    if (LoginService.isLoggedOut) {
        return;
    }

    LoginService.isLoggedOut = true;

    if (LoginService.activityDetector) {
        LoginService.activityDetector.stop();
        delete LoginService.activityDetector;
    }

    if (LoginService.userObject && LoginService.userObject.apiToken) {
      let url = LoginService.userObject.logoutUrl ||
          window.location.origin + window.location.pathname + window.location.search +
          (window.Config.isInternalAuth ? '#' : '#logout');

      let token = LoginService.userObject.apiToken;
      if (useKeycloakForAuth()) {
          LoginService.keycloakLogout(url, token.id_token, token.access_token, token.refresh_token);
      } else {
          LoginService.authServerLogout(url, token.id_token, token.access_token, token.refresh_token);
      }
    } else {
      logoutHelper();
      this.navigateToLogin();
    }
  }

  static createAndSubmitSloForm() {
      ConfigService.getInstance().getKeycloakUrl().then(function (keycloakUrl) {

          let form = document.createElement("form");
          form.setAttribute("method", "POST");
          form.setAttribute("action", keycloakUrl + "/saml2/logout");

          document.getElementsByTagName("body")[0].appendChild(form);

          form.submit();
      });
  }

  static authServerLogout(url, idToken, accessToken, refreshToken) {
      if (LoginService.userObject.external && LoginService.userObject.sloEnabled) {
          LoginService.createAndSubmitSloForm();
          return;
      }

      LoginService.revokeTokens(accessToken, refreshToken)
      .then ((response) => {
          ConfigService.getInstance().getKeycloakUrl().then(function (keycloakUrl) {
              var logoutUrl = keycloakUrl + '/connect/logout';
              fetch(logoutUrl, {
                  method: 'POST',
                  credentials: 'include',
                  body:  $.param({
                      client_id: encodeURIComponent(window.Config.keycloakClient),
                      id_token_hint: encodeURIComponent(idToken)
                  }),
                  headers: {
                      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                  },
                  redirect: "manual"
              })
              .then(function(response) {
                  logoutHelper();
                  window.location.href = url;
              },
              function(error) {
                  logoutHelper();
                  window.location.href = url;
              });
          });
      }, (error) => {
          logoutHelper();
          window.location.href = url;
      });
  }

  static revokeTokens(accessToken, refreshToken) {
      if (LoginService.tokensRevoked) {
          return Promise.resolve('');
      }
      LoginService.tokensRevoked = true;

      return new Promise(function(resolve, reject) {
          ConfigService.getInstance().getConfig().then(function(config) {
              ConfigService.getInstance().getKeycloakUrl().then(function (keycloakUrl) {
                  // console.log("revoking refresh token");

                  let revokeTokenUrl = keycloakUrl + '/oauth2/revoke';
                  fetch(revokeTokenUrl, {
                      method: 'POST',
                      credentials: 'include',
                      body:  $.param({
                          token: refreshToken
                      }),
                      headers: {
                          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                      },
                      redirect: "manual"
                  })
                  .then(function(response) {
                      return resolve(response);
                  },
                  function(error) {
                      return reject(error);
                  });
              }, function (error) {
                  return reject(error);
              });
          });
      });
  }

  static navigateToLogin(message) {
    if (message) {
      window.sessionStorage.setItem('login-error', message);
    }
    if (!this.isLoginPage()) {
      window.location.hash = '#/login';
      // window.location.reload(true); // todo do we need this?
      }
  }

  static isLoginPage() {
    return (window.location.hash === '#/'
            || window.location.hash === '#'
            || window.location.hash.indexOf('login') !== -1
            || window.location.hash.indexOf('logout') !== -1
            || window.location.hash.indexOf('setPassword') !== -1
            || window.location.hash.indexOf('orgRegistration') !== -1
            || window.location.hash.indexOf('register') !== -1);
  }

  static isLogoutPage() {
    return (window.location.hash.indexOf('logout') !== -1);
  }
  
  static setupPendo() {
    return setupPendo0(LoginService.userObject);
  }

}

function logoutHelper() {
      if (LoginService.userObject) {
          window.localStorage.removeItem('loggedIn-' + LoginService.userObject.username);
      }
      window.localStorage.removeItem('vtoken2');
      window.localStorage.removeItem('vusername');
      window.pendoInit = undefined;
      delete LoginService.userObject;
      delete LoginService.authPromise;
      LoginService.authInProgress = false;
      LoginService.tokensRevoked = true;
      LoginService.triedSessionLogin = false;

      if (LoginService.refreshTimer) {
        // console.log("refreshTokenTimer: cleared timer for logout");
        clearTimeout(LoginService.refreshTimer);
        LoginService.refreshTimer = undefined;
      }
}

function isTokenExpired() {
    if (!LoginService.userObject || !LoginService.userObject.apiToken) {
      console.log("warning: could not determine if token is expired due to userObject.apiToken not set");
      return false;
    }
    if (LoginService.userObject.authType === 'onecloud') {
        // console.log("skipping token expiration check - authType = onecloud");
        return false;
    }
    const token = LoginService.userObject.apiToken;
    const tokenParsed = token.access_token_parsed;
    const refreshToken = token.refresh_token;
    if (!tokenParsed || !refreshToken) {
        console.log("warning: tokenParsed or refreshToken null - forcing token expired.");
        return true;
    }

    let minValidity = 30; // 30 second buffer

    var expiresIn = tokenParsed.exp - Math.ceil(new Date().getTime() / 1000);
    if (minValidity) {
      expiresIn -= minValidity;
    }
    return expiresIn < 0;
}

function isValidCallbackUrl() {
    return (location.href.indexOf('state') > -1)
        // && (location.href.indexOf('session_state') > -1)
        && (location.href.indexOf('code') > -1);
}


function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
}

function useKeycloakForAuth() {
    if (window.Config.authMode === 'v1') {
        // console.log("useKeycloakForAuth: authMode=v1 --> true");
        return true;
    }
    if (window.Config.isInternalAuth === false) {
        // console.log("useKeycloakForAuth: isInternalAuth=false --> true");
        return true;
    }
    if (LoginService.authType === 'legacy') {
        // console.log("useKeycloakForAuth: authType=legacy --> true");
        return true;
    }

    // console.log("useKeycloakForAuth: false");
    return false;
}

function createOneCloudRequest(email) {
    return new Promise(function (resolve, reject) {
      return ConfigService.getInstance().getKeycloakUrl().then(function (keycloakUrl) {
        return ConfigService.getInstance().getKeycloakClient().then(function (keycloakClient) {
            var state = createUUID();
            var nonce = createUUID();
            var bareUrl = window.location.href.split(/[?#]/)[0];
            var redirectUri = encodeURIComponent(bareUrl + "#login/onecloud");
            let originalUrlObject = new URL(window.Config.originalUrl);
            let originalParams = originalUrlObject.searchParams;
            originalParams.delete('oc');
            let originalUrl = encodeURIComponent(originalUrlObject.toString());
            var callbackState = {
                state: state,
                nonce: nonce,
                redirectUri: redirectUri,
                originalUrl
            };
    
            window.sessionStorage.setItem("callbackState", JSON.stringify(callbackState));
    
            var url = keycloakUrl
                + "/oauth2/authorize"
                + "?realm=onecloud"
                + "&client_id=" + keycloakClient
                + "&response_mode=query"
                + "&response_type=code"
                + "&scope=openid"
                + "&state=" + state
                + "&nonce=" + nonce
                + "&email=" + encodeURIComponent(email)
                + "&redirect_uri=" + redirectUri;
    
            return resolve(url);
        });
      });
    });

}

function createSSORequest() {
    return new Promise(function (resolve, reject) {
        return ConfigService.getInstance().getKeycloakUrl().then(function (keycloakUrl) {
            return ConfigService.getInstance().getKeycloakClient().then(function (keycloakClient) {
                var state = createUUID();
                var nonce = createUUID();
                var bareUrl = window.location.href.split(/[?#]/)[0];
                var redirectUri = encodeURIComponent(bareUrl + "#login/sso");
                var callbackState = {
                    state: state,
                    nonce: nonce,
                    redirectUri: redirectUri,
                    originalUrl: encodeURIComponent(window.Config.originalUrl)
                };

                window.sessionStorage.setItem("callbackState", JSON.stringify(callbackState));

                var url = keycloakUrl;
                if (useKeycloakForAuth()) {
                    url += "/realms/" + window.Config.realmId + "/protocol/openid-connect/auth";
                    url += "?realm=" + window.Config.realmId + "&";
                } else {
                    url += "/oauth2/authorize?";
                }
                url += "client_id=" + keycloakClient
                    + "&redirect_uri=" + redirectUri
                    + "&state=" + state
                    + "&response_mode=query"
                    + "&response_type=code"
                    + "&scope=openid"
                    + "&nonce=" + nonce;
                if (LoginService.authType === 'saml') {
                    url += "&realm=" + encodeURIComponent(LoginService.orgDomain);
                }

                return reject(url);
            });
        });
    });
}

function createUUID() {
    return UtilsService.createUUID();
}

function setupPendo0(userObj) {
  if (window.pendo && !window.pendoInit) {
    const _pendoConfig = {
      visitor: {
        id: window.Config.environment + '_orgId_' + userObj.orgId + '_id_' + (userObj.oneClouduserId || userObj.userId),
        cpmmDialBackHours: userObj.cpmmDialBackHours.toString(),
        idleTimeoutMinutes: userObj.idleTimeoutMinutes.toString(),
        legacyAlertsHide: userObj.legacyAlertsHide.toString(),
        modules: userObj.features.toString(),
        enablePdf: userObj.enablePdf.toString(),
        farmG2: userObj.farmG2.toString(),
        features: userObj.features.toString(),
        timezoneDisplay: userObj.timezoneDisplay,
        timezoneId: userObj.timezoneId,
        roles: userObj.apiToken && userObj.roles ? userObj.roles.toString() : 'unknown',
        //Any additional user level data you may wish to send
      },
      account: {
        id: userObj.oneCloudTenantId || (window.Config.environment + '-id-' + userObj.orgId), //unique company identifier
        userTypeSession: window.Config.isInternalAuth ? 'internal auth' : 'sso',
        appSite: userObj.orgDomain,
        region: userObj.timezoneId,
        env: window.Config.environment,
        optIn: 'WX',
        companyName: userObj.orgName,
        //Any additional account level data you may wish to send
      },
    };

    window.pendoInit = 'true';
    window.pendo.initialize({ ..._pendoConfig });
  }
}